import { Adjustment } from './adjustment.model';
import { Base } from './base.model';
import { PeriodicReport } from './periodic-report.model';
import { ReportResponse } from './report-response.model';
import { SitePayment } from './site-payment.model';

import { Type } from '../decorators/type.decorator';
import { SiteBase } from '@shared/models/site-base.model';

export class PaymentPeriod extends Base {
  public siteVersionId: number;
  @Type(Adjustment) public adjustments: Adjustment[];
  public sequence: number;
  public startDate: Date;
  public endDate: Date;
  public ppt: number;
  public grossErt: number;
  public netErt: number;
  public netErtAdjustment: number;
  public deductionErt: number;
  public isVariablePeriod: boolean;
  public isPaymentEligible: boolean;
  public netPayout: number;
  public netPayoutAdjustment: number;
  public acrBufferErt: number;
  public paymentId: number;
  public reportResponseId: number;
  public reportId: number;
  public internalBufferErt: number;
  @Type(SitePayment) public payment: SitePayment;
  @Type(PeriodicReport) public report: PeriodicReport;
  @Type(ReportResponse) public reportResponse: ReportResponse;
}

export class PaymentPeriodSummary extends PaymentPeriod {
  public averagePpt: number;
  public netPaidPayout: number;
  public netPaidErt: number;
  public netPendingPayout: number;
  public netPendingErt: number;
  public rpNum: number;
  public status: string;
}

export class PaymentPeriodDetail extends PaymentPeriodSummary {
  public siteId: number;
  public area: number;
  public siteName: string;
  public parcelState: string;
  public acrProjectName: string;
  public acrProjectId: string;
  public acrProjectStartDate: Date;
  public enrollmentGroupName: string;
  public submittedDate: Date;
  public stripeAccountCreationDate: Date;
  public contractingStatus: string;
  public acrNetErt: number;
  @Type(SiteBase) public site: SiteBase;
}

export class PaymentPeriodDetailDashboard extends PaymentPeriodSummary {
  public siteId: number;
  public siteName: string;
  public siteStatus: string;
  public acrProjectId: string;
  public siteStatusCategory: string;
  public submittedDate: Date;
  public regionName: string;
  public enrollmentGroupName: string;
  public paymentDate: Date;
  public acrProjectName: string;
  public area: number;
  public contractingStatus: string;
  public parcelState: string;
  public acrNetErt: number;
}

export class PaidPaymentExport extends Base {
  public acrProjectName: string;
  public acrStartDate: Date;
  public startDate: Date;
  public endDate: Date;
  public netPendingPayout: number;
  public netPaidPayout: number;
  public expectedIssuance: number;
  public rpNumber: number;
}
